import React, { useState, useEffect } from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Checkbox, Typography } from '@mui/material';
import { Button } from '@mui/material';
import { USER_CHECK_LIST, USER_CHECK_LIST_SPANISH } from '../../constants';
import { Dialog } from '@mui/material';
import { DialogTitle } from '@mui/material';
import { DialogActions } from '@mui/material';
import { List } from '@mui/material';
import { ListItem } from '@mui/material';
import { ListItemButton } from '@mui/material';
import { ListItemText } from '@mui/material';
import { ListItemIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { initialClinic } from '../../api/APIServices';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';

const getMuiTheme = () => createTheme({
  components: {}
});

function UserCheckList() {

  const { t, i18n } = useTranslation('global');
  console.log(i18n.language);
  const { data } = useSelector((state) => state.user)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const params = useParams();
  const userId = params.userId
  const [open, setOpen] = useState(false);
  const [verifyIntakeQuestionnaire, setVerifyIntakeQuestionnaire] = useState(false);

  const [checked, setChecked] = useState([]);
  const [disableSubmit, setDisableSubmit] = useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setDisableSubmit(true)
    if (checked.length === USER_CHECK_LIST.length) {
      setDisableSubmit(false);
    }
  }, [checked])


  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleOnboarding = () => {
    //intakeDate:dayjs().format('YYYY-MM-DD')
    dispatch(initialClinic({ "userId": data.userId, "visit": true }));
    handleClose();
    navigate(`/user_details/${data.userId}`);
  }
  let ListOfUsers = i18n?.language === 'en' ? USER_CHECK_LIST : USER_CHECK_LIST_SPANISH;
  useEffect(() => {
    if (data && data?.completedTasks) {
      let intakeQ = data?.completedTasks.filter((obj) => {
        return obj.taskId === 'q:intake'
      })
      if (intakeQ && intakeQ.length === 1) {
        setVerifyIntakeQuestionnaire(true)
      }
    }

  }, [])

  return (
    <ThemeProvider theme={getMuiTheme()}>
      {data && false === ('intakeDate' in data) &&
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>

          <div style={{ width: '49%' }}>
            <div style={{ border: 'solid 1px #ccc', padding: '10px' }}>
              <Typography sx={{ fontWeight: 600, fontSize: '16px' }}>
                {t('intakeChecklist')}
              </Typography>
            </div>
            <div style={{ marginTop: '10px', border: 'solid 1px #ccc', padding: '10px' }}>
              <div style={{ height: '305px', overflow: 'auto' }}>
                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                  {ListOfUsers.map(({ id, name }) => {
                    const labelid = `checkbox-list-label-${id}`;

                    return (
                      <ListItem
                        key={id}
                        sx={{ paddingLeft: 0 }}
                      >
                        <ListItemButton sx={{
                          border: (checked.indexOf(id) !== -1) ? '1px solid #00C653' : '1px solid #ccc',
                          borderRadius: '10px',
                          marginBotton: '5px',

                          backgroundColor: (checked.indexOf(id) !== -1) ? '#00C6531A' : '#ffffff'
                        }}
                          onClick={handleToggle(id)} dense
                          disabled={id === 1 && !verifyIntakeQuestionnaire}

                        >

                          <ListItemText id={labelid} primary={`${name}`} />
                          <ListItemIcon>
                            <Checkbox
                              edge="start"
                              lable={name}
                              value={name}
                              checked={checked.indexOf(id) !== -1}
                              tabIndex={1}
                              disableRipple
                              inputProps={{ 'aria-labelledby': labelid }}
                            />
                          </ListItemIcon>

                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </div>
              <div style={{ display: 'flex', justifyContent: 'right', margin: '10px 0px' }}>
                <div>
                  <Button
                    type="submit"
                    color='primary'
                    variant="contained"
                    autoFocus
                    disabled={disableSubmit}
                    sx={{ borderRadius: '20px' }}
                    onClick={handleClickOpen}
                  >
                    {t('submit')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div style={{ width: '49%', border: 'solid 1px #ccc', padding: '10px' }}>
            <div style={{ marginTop: '0px' }}>
              <div style={{ height: '400px', overflow: 'auto' }}>
                <div style={{ marginBottom: '15px' }}>
                  <Typography sx={{ fontWeight: 600, fontSize: '16px' }}>
                   {t('clinicianInstructions')}
                  </Typography>
                </div>
                <div>
                  <Typography paragraph={true} className="checklistInstruction">
                    <Typography sx={{ fontWeight: 700, fontSize: '14px', marginRight: '5px' }} variant="title">
                     
                      {t('intakeQuestionnaire')} :
                    </Typography>
                   {t('qTextIntek')}
                  </Typography>
                </div>

                <div>
                  <Typography paragraph={true} mb={'10px'} className="checklistInstruction">
                    <Typography sx={{ fontWeight: 700, fontSize: '14px', marginRight: '5px' }} variant="title">
                      {t('educationalVideos')} :
                    </Typography>
                   {t('eTextIntek')}
                  </Typography>
                </div>
                <div>
                  <Typography paragraph={true} mb={'10px'} className="checklistInstruction">
                    <Typography sx={{ fontWeight: 700, fontSize: '14px', marginRight: '5px' }} variant="title">
                     {t('sensorPlacement')} :
                    </Typography>
                 {  t('sTextIntek')}
                  </Typography>
                </div>
                <div>
                  <Typography paragraph={true} mb={'10px'} className="checklistInstruction">
                    <Typography sx={{ fontWeight: 700, fontSize: '14px', marginRight: '5px' }} variant="title">
                     {t('pairSensor')} :
                    </Typography>
                    {t('pTextIntek')}
                  </Typography>
                </div>
                <div>
                  <Typography paragraph={true} mb={'10px'} className="checklistInstruction">
                    <Typography sx={{ fontWeight: 700, fontSize: '14px', marginRight: '5px' }} variant="title">
                      MVC, STS, TUG :
                    </Typography>
                    {t('mvcTextIntek')}

                  </Typography>
                </div>
                <div>
                  <Typography paragraph={true} mb={'10px'} className="checklistInstruction">
                    <Typography sx={{ fontWeight: 700, fontSize: '14px', marginRight: '5px' }} variant="title">
                      {t('exercise')} :
                    </Typography>
                   {t('exeTextIntek')}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("intake_confirmation_message")}
        </DialogTitle>

        <DialogActions>
          <Button sx={{ borderRadius: '20px' }} onClick={handleOnboarding}>{t('yes')}</Button>
          <Button color='primary' size='small' variant="contained" onClick={handleClose} autoFocus
            sx={{ borderRadius: '20px' }}
          >
            {t('no')}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>)
}

export default UserCheckList